import React from "react";

const TransactionContext = React.createContext(null);

export default TransactionContext;